// @core/api/endpoints/subscription/update_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SubscriptionResponse,
  UpdateSubscriptionRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update subscription
 * Updates subscription settings such as quantity, renewal preferences, or metadata. Does not change the plan; use plan-change for upgrades.
 */
export async function UpdateSubscription(
  subscription_id: string,
  data: UpdateSubscriptionRequest,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.put<SubscriptionResponse>(requestPath, data, requestOptions);
}
